import React from 'react';
import Input from '../components/form/FormikInput.jsx';
import axios from 'axios';
import { useFormik } from 'formik';
import { object } from 'yup';
import { string } from 'yup';
import Alert from 'react-s-alert';

const ForgotPassword = () => {
    const [sent, setSent] = React.useState(false);

    const { values, errors, touched, handleChange, handleSubmit, setFieldError } = useFormik({
        initialValues: { email: '' },
        validationSchema: object().shape({
            email: string().email().required()
        }),
        onSubmit: async (values) => {
            try {
                await axios.request({
                    url: `/customers/forgot`,
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: {
                        email: values.email
                    }
                });
                setSent(true);
            } catch (error) {
                console.error(error);
                if (error.response.data) {
                    setFieldError('email', error.response.data.message);
                } else {
                    Alert.error('There was an error finding your account.');
                }
            }
        }
    });

    return (
        <div className="container">
            <h1>Forgot Your Password?</h1>
            {!sent && (
                <form onSubmit={handleSubmit} noValidate>
                    <p>Please enter your email address. We'll email you a link to reset your password.</p>
                    <Input
                        id="email"
                        placeholder="Email Address"
                        label="Email Address"
                        type="email"
                        value={values.email}
                        touched={touched.email}
                        error={errors.email}
                        onChange={handleChange}
                        required
                    />
                    <button type="submit" className="button">
                        Continue
                    </button>
                </form>
            )}
            {sent && (
                <div>
                    <p>We've sent you a password reset link via email.</p>
                    <p>
                        If you don't receive an email, please check your spam folder or contact Customer Service at{' '}
                        <a href="mailto:customerservice@findaway.com">customerservice@findaway.com</a>.
                    </p>
                </div>
            )}
        </div>
    );
};

export default ForgotPassword;
